import { useQuery } from '@tanstack/react-query'
import { Button, Table } from '@bitcine/cinesend-theme/dist'
import useStore from '../../hooks/use_store'
import CollectionValue from '../collection_value'
import uuid from 'react-uuid'

const LocalizableLabels = ({ collection, schema, cycleID, airlineID }) => {
  const { data: languages, isLoading: isLangLoading } = useQuery([
    `languages?airlineId=${airlineID ?? ''}&schemaId=${schema?.id ?? ''}`,
  ])
  const {
    data: collectionValues,
    isLoading,
    error,
  } = useQuery([`collection-values`, `?collectionID=${collection.id}`, `&cycleID=${cycleID}`])
  const { deleteModel } = useStore()

  if (isLoading || isLangLoading) {
    return null
  }

  const nonLocalizedValues = collectionValues?.filter((opt) => !opt.language_id)
  const localizedValues = collectionValues?.filter((opt) => opt.language_id !== null)

  return (
    <Table
      status={{
        pending: isLoading,
        error: error,
        errorMessage: error?.message,
      }}
      widths={[200, ...languages.map(() => 200), 80]}
      header={{
        columns: [
          { text: 'Identifier label' },
          ...languages.map((opt) => ({ text: `${opt.eng_description} label`, key: opt.ife_code })),
          { text: '' },
        ],
      }}
      body={{
        data: nonLocalizedValues,
        row: {
          localizedValues: localizedValues,
          render: [
            (data) => <CollectionValue collection={collection} collectionValue={data} key={`identifier-${data.id}`} />,
            ...languages.map((language) => (data, index, { localizedValues }) => {
              const languageSpecificValue = localizedValues?.find(
                (v) => v.language_id === language.id && v.collection_value_id === data.id
              )
              return (
                <CollectionValue
                  collection={collection}
                  key={`lang-${data.id}-${language.id}`}
                  identifierCollectionValue={data}
                  collectionValue={languageSpecificValue}
                  language={language}
                />
              )
            }),
            (data) => (
              <Button
                icon='remove_circle_outline'
                secondary
                type='error'
                disabled={data.hidden_at}
                key={`delete-${data.id}`}
                onClick={() => {
                  deleteModel.mutate({ endpoint: 'collection-values', id: data.id, params: `?cycleID=${cycleID}` })
                }}
              />
            ),
          ],
        },
        empty: {
          title: 'No items found!',
          text: 'Create a new item to begin.',
          icon: 'add_circle_outline',
        },
      }}
    />
  )
}

export default LocalizableLabels
